import {
  AuditOutlined,
  CalendarOutlined,
  FileTextOutlined,
  LockOutlined,
  TeamOutlined,
  ProductOutlined,
} from '@ant-design/icons'
import { CUSTOMER_MANAGEMENT } from 'enrollment-platform/pages/CustomerManagement/paths'
import { DEMO_COMPANY_MANAGEMENT } from 'enrollment-platform/pages/DemoCompanyManagement/paths'
import { CENSUS_ONBOARDING } from 'enrollment-platform/pages/CustomerOnboarding/paths'
import { ENROLLMENT_OVERLAP } from 'enrollment-platform/pages/EnrollmentOverlap/paths'
import { ancillaryReportPath } from 'enrollment-platform/pages/AncillaryReport/paths'
import { PLAN_MANAGEMENT } from 'enrollment-platform/pages/PlanManagement/paths'
import { sharePointPath } from 'enrollment-platform/pages/SharePoint/paths'
import React from 'react'
import {
  CENSORY,
  DOCUMENT_CENTER,
  EXPENSE_REQUESTS_NAME,
  PROSPECTS_V2_NAME,
  PROSPECTS_V3_NAME,
  QLE,
  RECRUITING,
} from '../../routes/path-names'
import appIcon from './assets/app.png'
import buildingIcon from './assets/building.png'
import circlePlusIcon from './assets/circle-plus.png'
import expenseRequestsIcon from './assets/expense-requests.png'
import homeIcon from './assets/home.png'
import censusIcon from './assets/icon_census.png'
import lineChartIcon from './assets/line-chart.png'
import magnifyingGlassIcon from './assets/maginfying-glass.png'
import pickaxeIcon from './assets/pickaxe.png'

export const HomeTab = {
  href: '/',
  icon: homeIcon,
  text: 'Home',
  sortOrder: 10,
}

export const EmployeesTab = {
  href: '/employees',
  icon: magnifyingGlassIcon,
  text: 'Our people',
  sortOrder: 30,
}

export const EnrollmentDashboardTab = {
  href: '/enrollmentdashboard',
  icon: lineChartIcon,
  text: 'Enrollment',
  sortOrder: 20,
}

export const CustomerManagementTab = {
  href: `/${CUSTOMER_MANAGEMENT}`,
  icon: censusIcon,
  text: 'Customer Configuration',
  sortOrder: 20,
}

export const DemoCompanyManagementTab = {
  href: `/${DEMO_COMPANY_MANAGEMENT}`,
  icon: circlePlusIcon,
  text: 'Demo Companies',
  sortOrder: 25,
}

export const ExpenseTab = {
  href: EXPENSE_REQUESTS_NAME,
  icon: expenseRequestsIcon,
  text: 'Expense requests',
  sortOrder: 40,
}

export const AppManagerTab = {
  href: '/application-manager',
  icon: appIcon,
  text: 'Application engine',
  sortOrder: 50,
}

export const AppEngineTab = {
  href: '/application-engine',
  icon: appIcon,
  text: 'Application engine V2',
  sortOrder: 50,
}

export const AppQueueTab = {
  href: '/application-queue',
  icon: appIcon,
  text: 'Application queues',
  sortOrder: 55,
}

export const DataAndReportsTab = {
  href: '/dataandreports',
  icon: lineChartIcon,
  text: 'Data & Reports',
  sortOrder: 60,
}

export const AncillaryReportTab = {
  href: ancillaryReportPath(),
  icon: lineChartIcon,
  text: 'Ancillary Dashboard',
  sortOrder: 61,
}

export const DocumentCenterTab = {
  href: `/${DOCUMENT_CENTER}`,
  icon: <FileTextOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'Document Center',
  sortOrder: 58,
}

export const SharePointTab = {
  href: sharePointPath(),
  icon: <FileTextOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'SharePoint Portal',
  sortOrder: 59,
}

export const CensoryTab = {
  href: `/${CENSORY}`,
  icon: censusIcon,
  text: 'Censory',
  sortOrder: 65,
}

export const CensusMgmtTab = {
  href: '/census-management',
  icon: censusIcon,
  text: 'Census Management',
  sortOrder: 70,
}

export const CensusMgmtV2Tab = {
  href: '/v2-census-management',
  icon: censusIcon,
  text: 'Census Management V2',
  sortOrder: 75,
}

export const BulkTerminationsTab = {
  href: '/v2-census-management/bulk-terminations',
  icon: censusIcon,
  text: 'Bulk Terminations',
  sortOrder: 76,
}

export const TerminationTrackingTab = {
  href: '/v2-census-management/termination-tracking',
  icon: censusIcon,
  text: 'Termination Tracking',
  sortOrder: 77,
}

export const CensusReview = {
  href: '/census-review',
  icon: censusIcon,
  text: 'Census Review',
  sortOrder: 78,
}

export const CompanyTab = {
  href: '/company',
  icon: buildingIcon,
  text: 'Company profile',
  sortOrder: 80,
}

export const HealthPlanTab = {
  href: '/health-plans-dashboard/plan-summary-list',
  icon: circlePlusIcon,
  text: 'Health plans',
  sortOrder: 90,
}

export const PlanManagementTab = {
  href: PLAN_MANAGEMENT,
  icon: circlePlusIcon,
  text: 'Plan Management',
  sortOrder: 95,
}

export const PlanManagementV3Tab = {
  href: '/plans-v3',
  icon: circlePlusIcon,
  text: 'Plan Management V3',
  sortOrder: 95.5,
}

// Combined kill-switch for the two legacy plan-data tabs (Health Plan +
// Plan Management), now that Plan Management V3 is the primary experience.
// Backed by the EPS PlatformConfigurations GLOBAL flag store (not
// LaunchDarkly) so it can be flipped from Settings > Feature Flags without a
// deploy — see useNavigationLinks for where this is applied.
export const LEGACY_PLAN_MANAGEMENT_FLAG_KEY =
  'admin.plan-management-legacy.enabled'

// EPS GLOBAL flag for the platform-admin Ancillary Dashboard tab. Off only hides
// the tab; the page still opens from its URL.
export const ANCILLARY_REPORT_TAB_FLAG_KEY =
  'admin.reports.show-ancillary-report-tab'

// EPS GLOBAL flag for the platform-admin SharePoint Portal. Off hides the tab
// and SharePointRouteGate sends /sharepoint back to Home.
export const SHAREPOINT_PORTAL_FLAG_KEY = 'admin.sharepoint.enable-portal'

export const PlansV2Tab = {
  href: '/plans-v2',
  icon: circlePlusIcon,
  text: 'Plans',
  sortOrder: 96,
}

export const ProspectsTabV2 = {
  href: `/${PROSPECTS_V2_NAME}`,
  icon: pickaxeIcon,
  text: 'Prospects V2',
  sortOrder: 105,
}

export const ProspectsTabV2_1 = {
  href: `/${PROSPECTS_V3_NAME}`,
  icon: pickaxeIcon,
  text: 'Prospects V3',
  sortOrder: 106,
}

export const ToolsTab = {
  href: '/tools',
  icon: lineChartIcon,
  text: 'Tools',
  sortOrder: 110,
}

export const QLETab = {
  href: `/${QLE}`,
  icon: circlePlusIcon,
  text: 'Qualifying Life Events',
  sortOrder: 120,
}

export const RecruitingTab = {
  href: `/${RECRUITING}`,
  icon: <ProductOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'Recruiting',
  sortOrder: 121,
}

export const HRISTab = {
  href: '/hris',
  icon: censusIcon,
  text: 'HRIS',
  sortOrder: 130,
}

export const FinanceTab = {
  href: '/finance',
  icon: lineChartIcon,
  text: 'Finance',
  sortOrder: 140,
}

export const FundingInvoiceTab = {
  href: '/funding-invoice/invoice-list',
  icon: lineChartIcon,
  text: 'Funding Invoice',
  sortOrder: 145,
}

export const BenefitIntegrationsTab = {
  href: '/benefit-integrations',
  icon: circlePlusIcon,
  text: 'Benefit Integrations',
  sortOrder: 150,
}

export const CensusOnboardingTab = {
  href: `/${CENSUS_ONBOARDING}`,
  icon: <TeamOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'Census Onboarding',
  sortOrder: 135,
}

// TEMPORARY (EMS-10766): platform admins only. Listed in `hixmeOnlyLinks`
// below, which only the PlatformHixmeAdmin role receives.
export const EnrollmentOverlapTab = {
  href: `/${ENROLLMENT_OVERLAP}`,
  icon: <AuditOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'Enrollment Overlap',
  sortOrder: 156,
}

export const AccessControlTab = {
  href: '/permission-management',
  icon: <LockOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'Permission Management',
  sortOrder: 155,
}

export const OpenEnrollmentTab = {
  href: '/open-enrollment',
  icon: <CalendarOutlined style={{ fontSize: 18, color: '#8f9ea8' }} />,
  text: 'Open Enrollment',
  sortOrder: 25,
}

export const clientLinks = [
  HomeTab,
  EmployeesTab,
  CensusMgmtTab,
  CensusMgmtV2Tab,
  BulkTerminationsTab,
]

export const clientAdminLink = [
  HomeTab,
  EmployeesTab,
  OpenEnrollmentTab,
  CensusMgmtTab,
  CensusMgmtV2Tab,
  CompanyTab,
  BulkTerminationsTab,
  FundingInvoiceTab,
]

export const hixmeOnlyLinks = [
  HomeTab,
  EmployeesTab,
  OpenEnrollmentTab,
  ExpenseTab,
  AppManagerTab,
  AppEngineTab,
  AppQueueTab,
  DocumentCenterTab,
  DataAndReportsTab,
  CensusMgmtTab,
  CompanyTab,
  HealthPlanTab,
  BenefitIntegrationsTab,
  PlanManagementTab,
  ProspectsTabV2,
  ProspectsTabV2_1,
  ToolsTab,
  CensusMgmtV2Tab,
  BulkTerminationsTab,
  TerminationTrackingTab,
  CensusReview,
  HRISTab,
  FinanceTab,
  CensoryTab,
  FundingInvoiceTab,
  AccessControlTab,
  EnrollmentOverlapTab,
]

export const textLinks = []
